import { Show } from "shared/components";
import { Money } from "shared/types";
import { formatToCurrency, cx, has } from "shared/utils";
import { CurrencyDollar } from "untitledui-js-base";

interface Props {
  value: Money | null | undefined;
  className?: string;
  spanClassName?: string;
  isMobile?: boolean;
  title?: string;
  maximumFractionDigits?: number;
  isManuallyOverridden?: boolean;
}

export const RentAmount = ({
  value,
  isMobile,
  title,
  className,
  spanClassName,
  maximumFractionDigits,
  isManuallyOverridden
}: Props) => {
  return isMobile ? (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <CurrencyDollar className="shrink-0 stroke-content-500" size="20" />
        <p className="font-medium text-sm text-content-500">
          {title || "Rent amount"}
        </p>
      </div>

      <p className="font-medium text-sm text-content-500">
        {has(value?.cents)
          ? formatToCurrency(value, { maximumFractionDigits })
          : "--"}
      </p>
    </div>
  ) : (
    <p className={cx("font-medium text-content-1000", className)}>
      {has(value?.cents)
        ? formatToCurrency(value, { maximumFractionDigits })
        : "--"}
      <Show if={isManuallyOverridden}>
        <span className={cx("text-content-200", spanClassName)}>
          {" "}
          (Manually overridden)
        </span>
      </Show>
    </p>
  );
};
